export default "__VITE_ASSET__AhcenrAW__"